var map = {
	"./dashboard1.png": "7a3d",
	"./dashboard10.png": "e060",
	"./dashboard2.png": "9868",
	"./dashboard3.png": "9150",
	"./dashboard4.png": "6e97",
	"./dashboard5.png": "fcfd",
	"./dashboard6.png": "85b2",
	"./dashboard7.png": "5243",
	"./dashboard8.png": "afff",
	"./dashboard9.png": "6908"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3a59";